import { render } from "./mix-pane.vue?vue&type=template&id=6a15546b&scoped=true&ts=true"
import script from "./mix-pane.vue?vue&type=script&lang=ts"
export * from "./mix-pane.vue?vue&type=script&lang=ts"

import "./mix-pane.vue?vue&type=style&index=0&id=6a15546b&scoped=true&lang=css"

import exportComponent from "E:\\vs2019\\face-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a15546b"]])

export default __exports__